import { View } from "react-native";
import { Text } from "react-native-paper";

import { Modal } from "../../../components";

const FullDescModal = ({
  visible,
  onDismiss,
  name,
  description,
}: {
  visible: boolean;
  onDismiss(): void;
  name: string;
  description: string;
}) => (
  <Modal {...{ visible, onDismiss, title: "Description" }}>
    <View className="p-6">
      {name && <Text className="text-title-4 font-700">{name}</Text>}
      {description && <Text className="mt-5 text-regular-normal font-400 text-ink-dark">{description}</Text>}
    </View>
  </Modal>
);

export default FullDescModal;
